import React, { ReactNode } from 'react';
import { InternalLink } from './InternalLink';
import { Chip, ChipPassThroughOptions } from 'primereact/chip';
import { ExternalLink } from './ExternalLink';
import { BadgeProps } from 'primereact/badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareUpRight } from '@fortawesome/free-solid-svg-icons/faSquareUpRight';
import { faRightToBracket } from '@fortawesome/free-solid-svg-icons/faRightToBracket';

interface Props {
  idx?: number;
  label: string;
  internalLink?: string;
  externalLink?: string;
  images?: ReactNode;
  alt?: string;
}

export const CustomBadge: React.FC<Props> = (props: Props): ReactNode => {
  if (props.internalLink) {
    return (
      <InternalLink className={'h-2rem border-round'} idx={props.idx} to={props.internalLink} internalIcon={false}>
        <InnerChip idx={props.idx} disabled={false} {...props}
                   badge={{value: <FontAwesomeIcon icon={faRightToBracket}/>}}
        />
      </InternalLink>
    );
  }
  if (props.externalLink) {
    return (
      <ExternalLink className={'h-2rem border-round'} href={props.externalLink} externalIcon={false}>
        <InnerChip idx={props.idx} disabled={false} {...props}
                   badge={{value: <FontAwesomeIcon icon={faSquareUpRight}/>}}/>
      </ExternalLink>
    );
  }
  return <InnerChip idx={props.idx} disabled={true} {...props} />;
};

interface ChipProps {
  idx?: number;
  label: string;
  disabled: boolean;
  images?: ReactNode;
  badge?: BadgeProps;
  alt?: string;
}

const InnerChip: React.FC<ChipProps> = (props: ChipProps): ReactNode => {
  const pt: ChipPassThroughOptions = props.disabled ? {
    root: {
      className: 'h-2rem',
      style: {backgroundColor: '#f8f8f8'},
    },
  } : {};
  return <Chip pt={pt} template={
    <div className="h-2rem flex align-items-center gap-1 ml-2">
      {props.images &&
        <div className="flex h-2rem align-items-center justify-content-center gap-2">{props.images}</div>}
      {props.label}
      {props.badge?.value}
    </div>
  }/>;
};
